<template>
  <div>
    <v-container>
      <v-row no-gutters>
        <v-col cols="12">
          <div class="cs-register-intro-large pt-6 pb-0">
            <span v-html="$t('register.main.title')"></span>
          </div>
          <div class="cs-register-intro-small pt-6 pb-0">
            {{ $t('register.title.partnerType') }}
          </div>
        </v-col>
        <v-col cols="12" class="pl-0 pt-0">
          <v-radio-group v-model="accountData.partnerType" row>
            <v-radio color="primary" class="partner-type" :label="this.$t('register.partnerType.broker')"
              value="B"></v-radio>
            <v-radio color="primary" class="partner-type" :label="this.$t('register.partnerType.agent')"
              value="A"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <transition-group name="fade">
        <div key="register-block">
          <template v-if="accountData.partnerType">
            <template v-if="accountData.partnerType == 'B'">
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="cs-register-intro-small pt-6 pb-0">
                    {{ $t('register.title.selectInsuranceCompanies') }}
                  </div>
                </v-col>
                <v-col cols="12" class="pl-0 pt-0">
                  <template v-for="item in insComps">
                    <v-checkbox v-model="accountData.insuranceCompaniesB" class="ins-comps-type mb-n3" color="primary"
                      :label="item.value" :value="item.key" :key="item.key"></v-checkbox>
                  </template>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="cs-register-intro-small pt-6 pb-0">
                    {{ $t('register.title.selectInsuranceCompanies') }}
                  </div>
                </v-col>
                <v-col cols="12" class="pl-0 pt-0">
                  <v-radio-group v-model="accountData.insuranceCompaniesA" row>
                    <template v-for="item in insComps">
                      <v-radio class="ins-comps-type pb-4" color="primary" :label="item.value" :value="item.key"
                        :key="item.key"></v-radio>
                    </template>
                  </v-radio-group>
                </v-col>
              </v-row>
            </template>

            <template v-if="showOtherInsuranceCompany">
              <v-row no-gutters class="pb-10">
                <v-col cols="12">{{ $t('register.uploadPDF') }}</v-col>
                <v-col class="pt-3" cols="12" md="6">
                  <v-btn color="blue darken-1" outlined small :loading="buttonLoadingFR" :disabled="buttonLoadingFR"
                    @click="onSelectFileFR">
                    {{ $t('register.uploadPDF.fr') }}
                  </v-btn>
                  <input type="file" style="display: none" ref="fileInputFR" @change="uploadFileFR" />
                </v-col>
                <v-col class="pt-3" cols="12" md="6">
                  <v-btn color="blue darken-1" outlined small :loading="buttonLoadingNL" :disabled="buttonLoadingNL"
                    @click="onSelectFileNL">
                    {{ $t('register.uploadPDF.nl') }}
                  </v-btn>
                  <input type="file" style="display: none" ref="fileInputNL" @change="uploadFileNL" />
                </v-col>
              </v-row>
            </template>

            <v-row no-gutters>
              <v-col cols="12">
                <div class="cs-register-intro-small pt-6 pb-4">
                  {{ $t('register.title') }}
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" md="6" class="pr-md-8 pr-sm-0">
                <v-text-field outlined v-model.trim="accountData.email" :label="this.$t('register.email')"
                  :error-messages="emailErrors" @blur="
              $v.accountData.email.$touch();
            setInsuranceAgentEmail();
            "></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pl-md-8 pl-sm-0 pt-sm-12 pl-xs-0 pt-xs-12 pt-md-0">
                <v-text-field outlined v-model.trim="accountData.password" :label="this.$t('register.password')"
                  maxlength="30" :hint="this.$t('errors.forms.passwordField')" persistent-hint
                  :error-messages="passwordErrors" @blur="$v.accountData.password.$touch()"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pr-md-8 pr-sm-0">
                <v-text-field outlined v-model.trim="accountData.companyName" :label="this.$t('register.company')"
                  maxlength="80" :error-messages="companyNameErrors" @blur="
              $v.accountData.companyName.$touch();
            setCompany();
            "></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pl-md-8 pl-sm-0 pt-sm-12 pl-xs-0 pt-xs-12 pt-md-0">
                <v-text-field outlined v-model.trim="accountData.vat"
                  :label="this.$t('register.vatNbr')"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pr-md-8 pr-sm-0">
                <v-text-field outlined v-model.trim="accountData.affiliateNbr"
                  :label="this.$t('register.affiliateNbr')"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pl-md-8 pl-sm-0 pt-sm-12 pl-xs-0 pt-xs-12 pt-md-0">
                <v-radio-group v-model="accountData.lang" row>
                  <v-radio color="primary" :label="this.$t('register.frenchLanguage')" value="1"></v-radio>
                  <v-radio color="primary" :label="this.$t('register.dutchLanguage')" value="2"></v-radio>
                  <v-radio color="primary" :label="this.$t('register.englishLanguage')" value="3"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="6" class="pr-md-8 pr-sm-0">
                <v-text-field outlined v-model.trim="accountData.lastName" :label="this.$t('register.lastName')"
                  :error-messages="lastNameErrors" @blur="$v.accountData.lastName.$touch()"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pl-md-8 pl-sm-0 pt-sm-12 pl-xs-0 pt-xs-12 pt-md-0">
                <v-text-field outlined v-model.trim="accountData.firstName"
                  :label="this.$t('register.firstName')"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pr-md-8 pr-sm-0">
                <v-text-field outlined v-model.trim="accountData.phone"
                  :label="this.$t('register.phoneNbr')"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pl-md-8 pl-sm-0 pt-sm-12 pl-xs-0 pt-xs-12 pt-md-0">
                <v-text-field outlined v-model.trim="accountData.mobilePhone"
                  :label="this.$t('register.mobilePhoneNbr')"></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-sm-5 pt-sm-4">
                <span class="title">{{
              $t('register.subtitle.invoicingAddress')
            }}</span>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined counter="80" maxlength="80" v-model.trim="accountData.invoicingAddress1"
                  :label="this.$t('register.invoicingAddressLine1')" :error-messages="invoicingAddress1Errors"
                  @blur="$v.accountData.invoicingAddress1.$touch()"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined counter="80" maxlength="80" v-model.trim="accountData.invoicingAddress2"
                  :label="this.$t('register.invoicingAddressLine2')"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pr-md-8 pr-sm-0">
                <v-text-field outlined v-model.trim="accountData.invoicingZip" :label="this.$t('register.zip')"
                  maxlength="10" :error-messages="invoicingZipErrors"
                  @blur="$v.accountData.invoicingZip.$touch()"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pl-md-8 pl-sm-0 pt-sm-12 pl-xs-0 pt-xs-12 pt-md-0">
                <v-text-field outlined v-model.trim="accountData.invoicingCity" :label="this.$t('register.city')"
                  maxlength="80" :error-messages="invoicingCityErrors"
                  @blur="$v.accountData.invoicingCity.$touch()"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pr-md-8 pr-sm-0">
                <v-radio-group v-model="accountData.invoicingCountry" row @change="resetProvince">
                  <v-radio color="primary" :label="this.$t('register.belgium')" value="BE"
                    @change="resetProvince"></v-radio>
                  <v-radio color="primary" :label="this.$t('register.france')" value="FR"
                    @change="resetProvince"></v-radio>
                  <v-radio color="primary" :label="this.$t('register.luxembourg')" value="LU"
                    @change="resetProvince"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="6" class="pl-md-8 pl-sm-0 pt-sm-12 pl-xs-0 pt-xs-12 pt-md-0">
                <div v-if="accountData.invoicingCountry === 'BE'">
                  <v-select v-model="accountData.invoicingProvince" :items="provincesBE"
                    :label="this.$t('register.province')" outlined :error-messages="invoicingProvinceErrors"
                    @blur="$v.accountData.invoicingProvince.$touch()"></v-select>
                </div>
                <div v-if="accountData.invoicingCountry === 'FR'">
                  <v-select v-model="accountData.invoicingProvince" :items="provincesFR"
                    :label="this.$t('register.department')" outlined :error-messages="invoicingProvinceErrors"
                    @blur="$v.accountData.invoicingProvince.$touch()"></v-select>
                </div>
                <div v-if="accountData.invoicingCountry === 'LU'">
                  <v-select v-model="accountData.invoicingProvince" :items="provincesLU"
                    :label="this.$t('register.canton')" outlined :error-messages="invoicingProvinceErrors"
                    @blur="$v.accountData.invoicingProvince.$touch()"></v-select>
                </div>
              </v-col>
              <v-col cols="12" class="pb-sm-5 pt-sm-4">
                <span class="title">{{
              $t('register.subtitle.deliveryAddress')
            }}</span>
              </v-col>
              <v-col cols="12" class="pl-sm-0 pt-sm-12 pl-xs-0 pt-xs-12 pt-md-0">
                <v-text-field outlined v-model.trim="accountData.deliveryCompanyName"
                  :label="this.$t('register.company')"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pr-md-8 pr-sm-0">
                <v-text-field outlined v-model.trim="accountData.deliveryLastName" :label="this.$t('register.lastName')"
                  :error-messages="deliveryLastNameErrors"
                  @blur="$v.accountData.deliveryLastName.$touch()"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pl-md-8 pl-sm-0 pt-sm-12 pl-xs-0 pt-xs-12 pt-md-0">
                <v-text-field outlined v-model.trim="accountData.deliveryFirstName"
                  :label="this.$t('register.firstName')"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined counter="80" maxlength="80" v-model.trim="accountData.deliveryAddress1"
                  :label="this.$t('register.deliveryAddressLine1')" :error-messages="deliveryAddress1Errors"
                  @blur="$v.accountData.deliveryAddress1.$touch()"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined counter="80" maxlength="80" v-model.trim="accountData.deliveryAddress2"
                  :label="this.$t('register.deliveryAddressLine2')"></v-text-field>
              </v-col>

              <v-col cols="12" md="6" class="pr-md-8 pr-sm-0">
                <v-text-field outlined v-model.trim="accountData.deliveryZip" :label="this.$t('register.zip')"
                  maxlength="10" :error-messages="deliveryZipErrors"
                  @blur="$v.accountData.deliveryZip.$touch()"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pl-md-8 pl-sm-0 pt-sm-12 pl-xs-0 pt-xs-12 pt-md-0">
                <v-text-field outlined v-model.trim="accountData.deliveryCity" :label="this.$t('register.city')"
                  maxlength="80" :error-messages="deliveryCityErrors"
                  @blur="$v.accountData.deliveryCity.$touch()"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pr-md-8 pr-sm-0">
                <v-radio-group v-model="accountData.deliveryCountry" row>
                  <v-radio color="primary" :label="this.$t('register.belgium')" value="BE"></v-radio>
                  <v-radio color="primary" :label="this.$t('register.france')" value="FR"></v-radio>
                  <v-radio color="primary" :label="this.$t('register.luxembourg')" value="LU"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" class="pb-sm-5 pt-sm-5">
                <span class="title">
                  {{ $t('register.subtitle.cdData') }}
                </span>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined maxlength="40" v-model.trim="accountData.insuranceAgentName"
                  :label="this.$t('register.insuranceAgentName')" :error-messages="insuranceAgentNameErrors"
                  @blur="$v.accountData.insuranceAgentName.$touch()"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined maxlength="40" v-model.trim="accountData.insuranceAgentAddress"
                  :label="this.$t('register.insuranceAgentAddress')" :error-messages="insuranceAgentAddressErrors"
                  @blur="$v.accountData.insuranceAgentAddress.$touch()"></v-text-field>
              </v-col>

              <v-col cols="12" md="6" class="pr-md-8 pr-sm-0">
                <v-text-field outlined v-model.trim="accountData.insuranceAgentPhone"
                  :label="this.$t('register.insuranceAgentPhone')" :error-messages="insuranceAgentPhoneErrors"
                  @blur="$v.accountData.insuranceAgentPhone.$touch()"></v-text-field>
              </v-col>

              <v-col cols="12" md="6" class="pl-md-8 pl-sm-0 pt-sm-12 pl-xs-0 pt-xs-12 pt-md-0">
                <v-text-field outlined v-model.trim="accountData.insuranceAgentEmail"
                  :label="this.$t('register.insuranceAgentEmail')" :error-messages="insuranceAgentEmailErrors"
                  @blur="$v.accountData.insuranceAgentEmail.$touch()"></v-text-field>
              </v-col>
            </v-row>

            <v-row no-gutters v-if="!buttonClicked">
              <v-col cols="12" class="pt-10 pb-8">
                <v-btn class="primary" @click="createAccount">{{
              $t('register.button.createAccount')
                  }}</v-btn>
              </v-col>
            </v-row>

            <v-row no-gutters v-else>
              <v-col cols="12" class="pt-10 pb-8">
                <v-progress-linear indeterminate rounded height="7" color="primary"></v-progress-linear>
              </v-col>
            </v-row>
          </template>
        </div>
      </transition-group>
    </v-container>
  </div>
</template>

<script>
// import { validationMixin } from "vuelidate";
import { required, minLength, email } from 'vuelidate/lib/validators';
const fb = require('../firebaseConfig.js');
export default {
  name: 'register',
  data() {
    return {
      accountData: {
        partnerType: null,
        insuranceCompaniesB: [],
        insuranceCompaniesA: '',
        email: '',
        password: '',
        companyName: '',
        vat: '',
        affiliateNbr: '',
        lang: '1',
        lastName: '',
        firstName: '',
        phone: '',
        mobilePhone: '',
        invoicingAddress1: '',
        invoicingAddress2: '',
        invoicingZip: '',
        invoicingCity: '',
        invoicingCountry: 'BE',
        invoicingProvince: '',
        deliveryCompanyName: '',
        deliveryLastName: '',
        deliveryFirstName: '',
        deliveryAddress1: '',
        deliveryAddress2: '',
        deliveryZip: '',
        deliveryCity: '',
        deliveryCountry: 'BE',
        insuranceAgentName: '',
        insuranceAgentAddress: '',
        insuranceAgentPhone: '',
        insuranceAgentEmail: '',
        gdprConsent1: 1,
      },

      insComps: [],
      countries: [],

      buttonLoadingFR: false,
      buttonLoadingNL: false,

      provincesBE: [
        {
          value: 'BE_ANT',
          text: 'Antwerpen (Vlaanderen)',
        },
        {
          value: 'BE_BWL',
          text: 'Brabant Wallon (Wallonie)',
        },
        {
          value: 'BE_BXL',
          text: 'Bruxelles/Brussel (Bruxelles)',
        },
        {
          value: 'BE_HT',
          text: 'Hainaut (Wallonie)',
        },
        {
          value: 'BE_LG',
          text: 'Liège (Wallonie)',
        },
        {
          value: 'BE_LIM',
          text: 'Limburg (Vlaanderen)',
        },
        {
          value: 'BE_LUX',
          text: 'Luxembourg (Wallonie)',
        },
        {
          value: 'BE_NAM',
          text: 'Namur (Wallonie)',
        },
        {
          value: 'BE_OVL',
          text: 'Oost-Vlaanderen (Vlaanderen)',
        },
        {
          value: 'BE_VLB',
          text: 'Vlaams-Brabant (Vlaanderen)',
        },
        {
          value: 'BE_WVL',
          text: 'West-Vlaanderen (Vlaanderen)',
        },
      ],
      provincesFR: [
        {
          value: 'FR_01',
          text: 'Ain',
        },
        {
          value: 'FR_02',
          text: 'Aisne',
        },
        {
          value: 'FR_03',
          text: 'Allier',
        },
        {
          value: 'FR_05',
          text: 'Alpes Hautes)',
        },
        {
          value: 'FR_06',
          text: 'Alpes Maritimes',
        },
        {
          value: 'FR_07',
          text: 'Ardéche',
        },
        {
          value: 'FR_08',
          text: 'Ardennes',
        },
        {
          value: 'FR_09',
          text: 'Ariège',
        },
        {
          value: 'FR_10',
          text: 'Aube',
        },
        {
          value: 'FR_11',
          text: 'Aude',
        },
        {
          value: 'FR_12',
          text: 'Aveyron',
        },
        {
          value: 'FR_13',
          text: 'Bouches du Rhône',
        },
        {
          value: 'FR_14',
          text: 'Calvados',
        },
        {
          value: 'FR_15',
          text: 'Cantal',
        },
        {
          value: 'FR_16',
          text: 'Charente',
        },
        {
          value: 'FR_17',
          text: 'Charente Maritime',
        },
        {
          value: 'FR_18',
          text: 'Cher',
        },
        {
          value: 'FR_19',
          text: 'Corrèze',
        },
        {
          value: 'FR_21',
          text: ' Côte d"or',
        },
        {
          value: 'FR_22',
          text: ' Côtes d"armor',
        },
        {
          value: 'FR_23',
          text: 'Creuse',
        },
        {
          value: 'FR_24',
          text: 'Dordogne',
        },
        {
          value: 'FR_25',
          text: 'Doubs',
        },
        {
          value: 'FR_26',
          text: 'Drôme',
        },
        {
          value: 'FR_27',
          text: 'Eure',
        },
        {
          value: 'FR_28',
          text: 'Eure et Loir',
        },
        {
          value: 'FR_29',
          text: 'Finistère',
        },
        {
          value: 'FR_2A',
          text: 'Corse du sud',
        },
        {
          value: 'FR_2B',
          text: 'Haute corse',
        },
        {
          value: 'FR_30',
          text: 'Gard',
        },
        {
          value: 'FR_31',
          text: 'Haute Garonne',
        },
        {
          value: 'FR_32',
          text: 'Gers',
        },
        {
          value: 'FR_33',
          text: 'Gironde',
        },
        {
          value: 'FR_34',
          text: 'Hérault',
        },
        {
          value: 'FR_35',
          text: 'Ille-et-Vilaine',
        },
        {
          value: 'FR_36',
          text: 'Indre',
        },
        {
          value: 'FR_37',
          text: 'Indre et Loire',
        },
        {
          value: 'FR_38',
          text: 'Isère',
        },
        {
          value: 'FR_39',
          text: 'Jura',
        },
        {
          value: 'FR_40',
          text: 'Landes',
        },
        {
          value: 'FR_41',
          text: 'Loir et Cher',
        },
        {
          value: 'FR_42',
          text: 'Loire',
        },
        {
          value: 'FR_43',
          text: 'Haute Loire',
        },
        {
          value: 'FR_44',
          text: 'Loire Atlantique',
        },
        {
          value: 'FR_45',
          text: 'Loiret',
        },
        {
          value: 'FR_46',
          text: 'Lot',
        },
        {
          value: 'FR_47',
          text: 'Lot et Garonne',
        },
        {
          value: 'FR_48',
          text: 'Lozère',
        },
        {
          value: 'FR_49',
          text: 'Maine et Loire',
        },
        {
          value: 'FR_50',
          text: 'Manche',
        },
        {
          value: 'FR_51',
          text: 'Marne',
        },
        {
          value: 'FR_52',
          text: 'Haute Marne Haute',
        },
        {
          value: 'FR_53',
          text: 'Mayenne',
        },
        {
          value: 'FR_54',
          text: 'Meurthe et Moselle',
        },
        {
          value: 'FR_55',
          text: 'Meuse',
        },
        {
          value: 'FR_56',
          text: 'Morbihan',
        },
        {
          value: 'FR_57',
          text: 'Moselle',
        },
        {
          value: 'FR_58',
          text: ' Nièvre',
        },
        {
          value: 'FR_59',
          text: 'Nord',
        },
        {
          value: 'FR_60',
          text: 'Oise',
        },
        {
          value: 'FR_61',
          text: 'Orne',
        },
        {
          value: 'FR_62',
          text: 'Pas de Calais',
        },
        {
          value: 'FR_63',
          text: 'Puy de Dôme',
        },
        {
          value: 'FR_64',
          text: 'Pyrénées Atlantiques',
        },
        {
          value: 'FR_65',
          text: 'Hautes Pyrénées',
        },
        {
          value: 'FR_66',
          text: 'Pyrénées Orientales',
        },
        {
          value: 'FR_67',
          text: 'Bas Rhin Bas',
        },
        {
          value: 'FR_68',
          text: 'Haut Rhin',
        },
        {
          value: 'FR_69',
          text: 'Rhône',
        },
        {
          value: 'FR_70',
          text: 'Haute Saône',
        },
        {
          value: 'FR_71',
          text: 'Saône et Loire',
        },
        {
          value: 'FR_72',
          text: 'Sarthe',
        },
        {
          value: 'FR_73',
          text: 'Savoie',
        },
        {
          value: 'FR_74',
          text: 'Haute Savoie',
        },
        {
          value: 'FR_75',
          text: 'Paris',
        },
        {
          value: 'FR_76',
          text: 'Seine Maritime',
        },
        {
          value: 'FR_77',
          text: 'Seine et Marne',
        },
        {
          value: 'FR_78',
          text: 'Yvelines',
        },
        {
          value: 'FR_79',
          text: 'Deux Sèvres',
        },
        {
          value: 'FR_80',
          text: 'Somme',
        },
        {
          value: 'FR_81',
          text: 'Tarn',
        },
        {
          value: 'FR_82',
          text: 'Tarn et Garonne',
        },
        {
          value: 'FR_83',
          text: 'Var',
        },
        {
          value: 'FR_84',
          text: 'Vaucluse',
        },
        {
          value: 'FR_85',
          text: 'Vendée',
        },
        {
          value: 'FR_86',
          text: 'Vienne',
        },
        {
          value: 'FR_87',
          text: 'Haute Vienne',
        },
        {
          value: 'FR_88',
          text: 'Vosges',
        },
        {
          value: 'FR_89',
          text: 'Yonne',
        },
        {
          value: 'FR_90',
          text: 'Territoire de Belfort',
        },
        {
          value: 'FR_91',
          text: 'Essonne',
        },
        {
          value: 'FR_92',
          text: 'Hauts de Seine',
        },
        {
          value: 'FR_93',
          text: 'Seine Saint Denis',
        },
        {
          value: 'FR_94',
          text: 'Val de Marne',
        },
        {
          value: 'FR_95',
          text: 'Val d"oise',
        },
        {
          value: 'FR_971',
          text: 'Guadeloupe',
        },
        {
          value: 'FR_972',
          text: 'Martinique',
        },
        {
          value: 'FR_973',
          text: 'Guyane',
        },
        {
          value: 'FR_974',
          text: 'Réunion',
        },
        {
          value: 'FR_976',
          text: 'Mayotte',
        },
      ],
      provincesLU: [
        {
          value: 'LU_01',
          text: 'Canton de Capellen',
        },
        {
          value: 'LU_02',
          text: 'Canton de Clervaux',
        },
        {
          value: 'LU_03',
          text: 'Canton de Diekirch',
        },
        {
          value: 'LU_04',
          text: "Canton d'Echternach",
        },
        {
          value: 'LU_05',
          text: "Canton d'Esch-sur-Alzette",
        },
        {
          value: 'LU_06',
          text: 'Canton de Grevenmacher',
        },
        {
          value: 'LU_07',
          text: 'Canton de Luxembourg',
        },
        {
          value: 'LU_08',
          text: 'Canton de Mersch',
        },
        {
          value: 'LU_09',
          text: 'Canton de Redange',
        },
        {
          value: 'LU_10',
          text: 'Canton de Remich',
        },
        {
          value: 'LU_11',
          text: 'Canton de Vianden',
        },
        {
          value: 'LU_12',
          text: 'Canton de Wiltz',
        },
      ],
      buttonClicked: false,
    };
  },
  validations: {
    accountData: {
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(8),
      },
      companyName: {
        required,
      },
      lastName: {
        required,
      },
      invoicingAddress1: {
        required,
      },
      invoicingZip: {
        required,
      },
      invoicingCity: {
        required,
      },
      invoicingProvince: {
        required,
      },
      deliveryLastName: {
        required,
      },
      deliveryAddress1: {
        required,
      },
      deliveryZip: {
        required,
      },
      deliveryCity: {
        required,
      },
      insuranceAgentName: {
        required,
      },
      insuranceAgentAddress: {
        required,
      },
      insuranceAgentPhone: {
        required,
      },
      insuranceAgentEmail: {
        required,
        email,
      },
    },
  },
  watch: {
    'accountData.invoicingCountry': {
      handler: function (after) {
        this.accountData.deliveryCountry = after;
      },
      deep: true,
    },
    'accountData.email': {
      handler: function (after) {
        this.accountData.insuranceAgentEmail = after;
      },
      deep: true,
    },
    'accountData.phone': {
      handler: function (after) {
        this.accountData.insuranceAgentPhone = after;
      },
      deep: true,
    },
    'accountData.companyName': {
      handler: function (after) {
        this.accountData.deliveryCompanyName = after;
        this.accountData.insuranceAgentName = after;
      },
      deep: true,
    },
    'accountData.firstName': {
      handler: function (after) {
        this.accountData.deliveryFirstName = after;
      },
      deep: true,
    },
    'accountData.lastName': {
      handler: function (after) {
        this.accountData.deliveryLastName = after;
      },
      deep: true,
    },
    'accountData.invoicingAddress1': {
      handler: function (after) {
        this.accountData.deliveryAddress1 = after;

        let intermediaryAddress =
          ' - ' + this.accountData.deliveryAddress2 + ' - ';
        if (this.accountData.deliveryAddress2.trim().length == 0) {
          intermediaryAddress = ' - ';
        }
        this.accountData.insuranceAgentAddress =
          after +
          intermediaryAddress +
          this.accountData.invoicingZip +
          ' ' +
          this.accountData.invoicingCity;
      },
      deep: true,
    },
    'accountData.invoicingAddress2': {
      handler: function (after) {
        this.accountData.deliveryAddress2 = after;

        let intermediaryAddress =
          ' - ' + this.accountData.deliveryAddress2 + ' - ';
        if (this.accountData.deliveryAddress2.trim().length == 0) {
          intermediaryAddress = ' - ';
        }

        this.accountData.insuranceAgentAddress =
          this.accountData.deliveryAddress1 +
          intermediaryAddress +
          this.accountData.invoicingZip +
          ' ' +
          this.accountData.invoicingCity;
      },
      deep: true,
    },
    'accountData.invoicingZip': {
      handler: function (after) {
        this.accountData.deliveryZip = after;

        let intermediaryAddress =
          ' - ' + this.accountData.deliveryAddress2 + ' - ';
        if (this.accountData.deliveryAddress2.trim().length == 0) {
          intermediaryAddress = ' - ';
        }

        this.accountData.insuranceAgentAddress =
          this.accountData.deliveryAddress1 +
          intermediaryAddress +
          after +
          ' ' +
          this.accountData.invoicingCity;
      },
      deep: true,
    },
    'accountData.invoicingCity': {
      handler: function (after) {
        this.accountData.deliveryCity = after;

        let intermediaryAddress =
          ' - ' + this.accountData.deliveryAddress2 + ' - ';
        if (this.accountData.deliveryAddress2.trim().length == 0) {
          intermediaryAddress = ' - ';
        }

        this.accountData.insuranceAgentAddress =
          this.accountData.deliveryAddress1 +
          intermediaryAddress +
          this.accountData.invoicingZip +
          ' ' +
          after;
      },
      deep: true,
    },
  },
  methods: {
    resetProvince() {
      this.accountData.invoicingProvince = '';
    },
    setInsuranceAgentEmail() {
      this.accountData.insuranceAgentEmail = this.accountData.email;
    },
    setCompany() {
      this.accountData.insuranceAgentName = this.accountData.companyName;
      this.accountData.deliveryCompanyName = this.accountData.companyName;
    },
    createAccount() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$notify({
          type: 'error',
          title: this.$t('errors.forms.errorFieldsNotificationTitle'),
          text: this.$t('errors.forms.errorFieldsNotificationContent'),
        });
      } else {
        this.buttonClicked = true;
        const createAccount = fb.fnct.httpsCallable('createUser');
        const payload = {
          email: this.accountData.email,
          password: this.accountData.password,
          companyName: this.accountData.companyName,
          vat: this.accountData.vat,
          affiliateNbr: this.accountData.affiliateNbr,
          lang: parseInt(this.accountData.lang, 10),
          lastName: this.accountData.lastName,
          firstName: this.accountData.firstName,
          phone: this.accountData.phone,
          mobilePhone: this.accountData.mobilePhone,
          invoicingAddress1: this.accountData.invoicingAddress1,
          invoicingAddress2: this.accountData.invoicingAddress2,
          invoicingZip: this.accountData.invoicingZip,
          invoicingCity: this.accountData.invoicingCity,
          invoicingCountry: this.accountData.invoicingCountry,
          invoicingProvince: this.accountData.invoicingProvince,
          deliveryCompanyName: this.accountData.deliveryCompanyName,
          deliveryLastName: this.accountData.deliveryLastName,
          deliveryFirstName: this.accountData.deliveryFirstName,
          deliveryAddress1: this.accountData.deliveryAddress1,
          deliveryAddress2: this.accountData.deliveryAddress2,
          deliveryZip: this.accountData.deliveryZip,
          deliveryCity: this.accountData.deliveryCity,
          deliveryCountry: this.accountData.deliveryCountry,
          insuranceAgentName: this.accountData.insuranceAgentName,
          insuranceAgentAddress: this.accountData.insuranceAgentAddress,
          insuranceAgentPhone: this.accountData.insuranceAgentPhone,
          insuranceAgentEmail: this.accountData.insuranceAgentEmail,
          insuranceCompanies: this.insuranceCompanies,
          partnerType: this.accountData.partnerType,
          gdprConsent1: this.accountData.gdprConsent1,
        };
        createAccount(payload)
          .then(() => {
            return fb.auth.signInWithEmailAndPassword(
              this.accountData.email,
              this.accountData.password
            );
          })
          .then((userCredential) => {
            this.$store.commit('SET_CURRENT_USER', userCredential.user);
            this.$store.dispatch('fetchUserProfile');
            this.$router.push('newAccount');
          })
          .catch((error) => {
            this.buttonClicked = false;
            let errorMsg = JSON.stringify(error.message);
            if (error.message == 'email-already-exists') {
              errorMsg = this.$t(
                'errors.forms.errorRegistration.emailAlreadyExists'
              );
            } else if (error.message == 'Error: company-already-exists') {
              errorMsg = this.$t(
                'errors.forms.errorRegistration.companyAlreadyExists'
              );
            }
            this.$notify({
              type: 'error',
              title: this.$t('errors.forms.errorRegistration.title'),
              text: errorMsg,
              duration: 10000,
            });
          });
      }
    },
    onSelectFileFR() {
      this.$refs.fileInputFR.click();
    },
    onSelectFileNL() {
      this.$refs.fileInputNL.click();
    },
    uploadFileFR(evt) {
      const file = evt.target.files[0];
      this.uploadFile(file, 'fr');
    },
    uploadFileNL(evt) {
      const file = evt.target.files[0];
      this.uploadFile(file, 'nl');
    },
    uploadFile(file, lng) {
      const fileName = file.name;
      if (!fileName.match(/.(pdf|PDF)$/i)) {
        self.$notify({
          type: 'error',
          title: self.$t('errors.forms.errorImageNotImageTitle'),
          text: self.$t('errors.forms.errorImageNotImageContent'),
        });
      } else if (fileName.lastIndexOf('.') <= 0) {
        self.$notify({
          type: 'error',
          title: self.$t('errors.forms.errorImageFileInvalidTitle'),
          text: self.$t('errors.forms.errorImageFileInvalidContent'),
        });
      } else {
        const metadata = {
          contentType: file.type,
        };

        const uuid = this.generateUUID();
        const storageFileName = uuid + '.' + fileName.split('.').pop();

        const storageRef = fb.storage.ref();
        const fileRef = storageRef.child('otherGreenCards/' + storageFileName);

        if (lng === 'fr') {
          this.buttonLoadingFR = true;
        } else {
          this.buttonLoadingNL = true;
        }

        fileRef
          .put(file, metadata)
          .then(() => {
            if (lng === 'fr') {
              this.buttonLoadingFR = false;
            } else {
              this.buttonLoadingNL = false;
            }
          })
          .catch((error) => {
            if (lng === 'fr') {
              this.buttonLoadingFR = false;
            } else {
              this.buttonLoadingNL = false;
            }
            this.$notify({
              type: 'error',
              title: this.$t('errors.forms.errorOCRTitle'),
              text:
                this.$t('errors.forms.errorOCRContent') + ': ' + error.message,
            });
          });
      }
    },
    generateUUID() {
      let d = new Date().getTime();
      if (
        typeof performance !== 'undefined' &&
        typeof performance.now === 'function'
      ) {
        d += performance.now(); //use high-precision timer if available
      }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          let r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
    },
  },
  computed: {
    insuranceCompanies() {
      if (this.accountData.partnerType === 'A') {
        return this.accountData.insuranceCompaniesA;
      } else if (this.accountData.partnerType === 'B') {
        return this.accountData.insuranceCompaniesB;
      } else {
        return null;
      }
    },
    showOtherInsuranceCompany() {
      if (this.accountData.partnerType === 'A') {
        return this.accountData.insuranceCompaniesA === 'OTHER';
      } else if (this.accountData.partnerType === 'B') {
        return this.accountData.insuranceCompaniesB.includes('OTHER');
      } else {
        return false;
      }
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.accountData.email.$dirty) return errors;
      !this.$v.accountData.email.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      !this.$v.accountData.email.email &&
        errors.push(this.$t('errors.forms.mandatoryFieldAndEmail'));
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.accountData.password.$dirty) return errors;
      !this.$v.accountData.password.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      !this.$v.accountData.password.minLength &&
        errors.push(this.$t('errors.forms.passwordField'));
      return errors;
    },
    companyNameErrors() {
      const errors = [];
      if (!this.$v.accountData.companyName.$dirty) return errors;
      !this.$v.accountData.companyName.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.accountData.lastName.$dirty) return errors;
      !this.$v.accountData.lastName.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    invoicingAddress1Errors() {
      const errors = [];
      if (!this.$v.accountData.invoicingAddress1.$dirty) return errors;
      !this.$v.accountData.invoicingAddress1.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    invoicingZipErrors() {
      const errors = [];
      if (!this.$v.accountData.invoicingZip.$dirty) return errors;
      !this.$v.accountData.invoicingZip.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    invoicingCityErrors() {
      const errors = [];
      if (!this.$v.accountData.invoicingCity.$dirty) return errors;
      !this.$v.accountData.invoicingCity.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    invoicingProvinceErrors() {
      const errors = [];
      if (!this.$v.accountData.invoicingProvince.$dirty) return errors;
      !this.$v.accountData.invoicingProvince.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    deliveryLastNameErrors() {
      const errors = [];
      if (!this.$v.accountData.deliveryLastName.$dirty) return errors;
      !this.$v.accountData.deliveryLastName.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    deliveryAddress1Errors() {
      const errors = [];
      if (!this.$v.accountData.deliveryAddress1.$dirty) return errors;
      !this.$v.accountData.deliveryAddress1.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    deliveryZipErrors() {
      const errors = [];
      if (!this.$v.accountData.deliveryZip.$dirty) return errors;
      !this.$v.accountData.deliveryZip.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    deliveryCityErrors() {
      const errors = [];
      if (!this.$v.accountData.deliveryCity.$dirty) return errors;
      !this.$v.accountData.deliveryCity.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    insuranceAgentNameErrors() {
      const errors = [];
      if (!this.$v.accountData.insuranceAgentName.$dirty) return errors;
      !this.$v.accountData.insuranceAgentName.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    insuranceAgentAddressErrors() {
      const errors = [];
      if (!this.$v.accountData.insuranceAgentAddress.$dirty) return errors;
      !this.$v.accountData.insuranceAgentAddress.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    insuranceAgentPhoneErrors() {
      const errors = [];
      if (!this.$v.accountData.insuranceAgentPhone.$dirty) return errors;
      !this.$v.accountData.insuranceAgentPhone.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      return errors;
    },
    insuranceAgentEmailErrors() {
      const errors = [];
      if (!this.$v.accountData.insuranceAgentEmail.$dirty) return errors;
      !this.$v.accountData.insuranceAgentEmail.required &&
        errors.push(this.$t('errors.forms.mandatoryField'));
      !this.$v.accountData.insuranceAgentEmail.email &&
        errors.push(this.$t('errors.forms.mandatoryFieldAndEmail'));
      return errors;
    },
  },
  mounted: function () {
    const insComps = JSON.parse(JSON.stringify(this.$t('insuranceCompanies')));
    Object.keys(insComps).forEach((element) => this.insComps.push(JSON.parse(JSON.stringify({ key: element, value: insComps[element] }))));
  },
};
</script>

<style scoped>
.cs-register-intro-large {
  background-color: #ffffff;
  font-family: 'Raleway', sans-serif !important;
  font-size: 36px;
  font-style: normal;
  font-weight: 900;
  line-height: 1.109;
  color: #1976d2;
  margin-bottom: 12px;
}

.cs-register-intro-medium {
  background-color: #ffffff;
  font-family: 'Raleway', sans-serif !important;
  font-size: 24px;
  font-style: normal;
  font-weight: 900;
  line-height: 1.09;
  color: #164396;
  margin-bottom: 12px;
}

.cs-register-intro-small {
  background-color: #ffffff;
  font-family: 'Raleway', sans-serif !important;
  font-size: 24px;
  font-style: normal;
  font-weight: 800;
  line-height: 1.09;
  color: #164396;
  margin-bottom: 8px;
  margin-top: 10px;
}

.partner-type>>>label {
  font-size: 22px;
}

.ins-comps-type>>>label {
  font-size: 18px;
}

.fade-enter-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-enter {
  opacity: 0;
}
</style>
